var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.163,
    height: 29.9,
    viewBox: "0 0 26.163 29.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-bell",
    "data-name": "Icon awesome-bell",
    d: "M13.081,29.9a3.737,3.737,0,0,0,3.736-3.737H9.345A3.737,3.737,0,0,0,13.081,29.9ZM25.66,21.157c-1.128-1.212-3.239-3.036-3.239-9.01a9.222,9.222,0,0,0-7.471-9.061V1.869a1.868,1.868,0,1,0-3.735,0V3.086a9.222,9.222,0,0,0-7.471,9.061c0,5.974-2.111,7.8-3.239,9.01A1.825,1.825,0,0,0,0,22.425a1.87,1.87,0,0,0,1.875,1.869H24.288a1.87,1.87,0,0,0,1.875-1.869,1.824,1.824,0,0,0-.5-1.268Z",
    transform: "translate(0)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.71ad0fab3be908e3745f10124f6ee3b0.svg";
export { ForwardRef as ReactComponent };